export const smallBreakpoint = 420;
export const mediumBreakpoint = 600;
export const largeBreakpoint = 1024;
export const xlargeBreakpoint = 1440;

export default [smallBreakpoint, mediumBreakpoint, largeBreakpoint, xlargeBreakpoint];
